import { formatNumber } from 'utils/numberFormat';
import { HTMLAttributes, memo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { DownOutlined } from '@ant-design/icons';
import Fold from './Fold';
import { DetailItem, Amount, Detail, priceRender } from './TradeDetailPaymentLazada';

export interface TradeIncomeAmountProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
  defaultFold?: boolean;
}

/** shopee 买家实付金额 */
function TradePaymentAmountShopee(props: TradeIncomeAmountProps) {
  const { trade, defaultFold = true, className, ...otherProps } = props;

  const { unit, buyerPayment } = trade;

  const { t } = useTranslate();

  const [isfold, setIsfold] = useState(defaultFold);

  const total = priceRender(buyerPayment?.buyerTotalAmount, (val) => {
    return (
      <DetailItem
        key="total"
        onClick={() => setIsfold((isfold) => !isfold)}
        style={
          className === 'tradeDetail'
            ? { border: '1px solid #F0F2F5', padding: '0 16px', lineHeight: '40px' }
            : {}
        }
      >
        <span style={className === 'tradeDetail' ? { fontWeight: 'bold' } : {}}>
          {t('trade.买家实付金额')}
        </span>
        {className !== 'tradeDetail' ? (
          <Amount isfold={isfold}>
            <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
            <DownOutlined />
          </Amount>
        ) : null}
      </DetailItem>
    );
  });

  const detail = (
    <Detail
      key="detail"
      style={
        className === 'tradeDetail'
          ? { background: 'none', border: '1px solid #F0F2F5', borderTop: 'none' }
          : {}
      }
    >
      {priceRender(buyerPayment?.itemPrice, (val) => {
        return (
          <li>
            <dt>{t('商品金额')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.productProtection, (val) => {
        return (
          <li>
            <dt>{t('商品险')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.buyerPaidShippingFee, (val) => {
        return (
          <li>
            <dt>{t('trade.运费')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.shippingFeeSst, (val) => {
        return (
          <li>
            <dt>{t('买家支付运费SST')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.voucherFromPlatform, (val) => {
        return (
          <li>
            <dt>{t('Shopee商品折扣补贴')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.voucherFromSeller, (val) => {
        return (
          <li>
            <dt>{t('trade.卖家券')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.coins, (val) => {
        return (
          <li>
            <dt>{t('trade.Shopee币折抵')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.creditCardPromotion, (val) => {
        return (
          <li>
            <dt>{t('trade.信用卡折扣')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.crossBorderTax, (val) => {
        return (
          <li>
            <dt>{t('trade.进口税')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.icmsTax, (val) => {
        return (
          <li>
            <dt>{t('ICMS')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.otherTaxes, (val) => {
        return (
          <li>
            <dt>{t('其他税费')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.serviceFee, (val) => {
        return (
          <li>
            <dt>{t('服务费')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.buyerTransactionFee, (val) => {
        return (
          <li>
            <dt>{t('trade.买家交易费用')}</dt>
            <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
      {priceRender(buyerPayment?.buyerTotalAmount, (val) => {
        return (
          <li>
            <dt>{t('trade.买家实付金额')}</dt>
            <dd className="colorFont">{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
          </li>
        );
      })}
    </Detail>
  );
  return total ? (
    <Fold
      isfold={isfold}
      fixedCount={1}
      nodeList={[total, detail]}
      defaultFixedHeight={32}
      {...otherProps}
      style={className === 'tradeDetail' ? { marginBottom: '16px' } : {}}
    />
  ) : null;
}

export default memo(TradePaymentAmountShopee);
